import { queryOptions } from '@tanstack/react-query';
import { axios } from '@/lib/utils/axios';
import type { OrganizationMember } from '../../common/organization';
import { getResponse } from '../common';
import { API_URLS } from '../query.client';

async function getOrganizationMembers(organizationId: string): Promise<OrganizationMember[]> {
	const response = await axios.get(API_URLS.ORGANIZATIONS.MEMBERS(organizationId));
	return getResponse<OrganizationMember[]>(response.data) ?? [];
}

/** Enabled users of an organisation, sorted by name (responsible-specialist picker). */
export function getOrganizationMembersOptions(organizationId: string | undefined) {
	return queryOptions({
		queryKey: ['organizations', organizationId, 'members'],
		queryFn: () => getOrganizationMembers(organizationId as string),
		enabled: !!organizationId,
	});
}
